'use client';

import { ToolsTranslations } from '@/lib/translations/types';

type Values = { indexLevel: number; riskFreeRatePercent: number; earningsEstimate: number };

interface Props {
  values: Values;
  onValuesChange: (field: keyof Values, value: number) => void;
  translations: ToolsTranslations['equityRiskPremium'];
}

export default function CalculatorInputs({ values, onValuesChange, translations }: Props) {
  const parseNumber = (raw: string) => Number(raw.replace(/\s/g, '').replace(/,/g, '.'));
  const handleChange = (field: keyof Values) => (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = parseNumber(e.target.value);
    onValuesChange(field, isNaN(value) ? 0 : value);
  };

  const inputClass = "w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500";

  return (
    <div className="space-y-6">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">{translations.indexLevel}</label>
        <input type="text" value={values.indexLevel.toLocaleString('sv-SE')} onChange={handleChange('indexLevel')} className={inputClass} placeholder="0" />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1 flex items-center gap-2">
          {translations.riskFreeRate}
        </label>
        <input type="text" value={`${values.riskFreeRatePercent.toLocaleString('sv-SE')}%`} onChange={handleChange('riskFreeRatePercent')} className={inputClass} placeholder="0" />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">{translations.earningsEstimate}</label>
        <input type="text" value={values.earningsEstimate.toLocaleString('sv-SE')} onChange={handleChange('earningsEstimate')} className={inputClass} placeholder="0" />
      </div>
    </div>
  );
}


